module.exports = __webpack_public_path__ + "static/media/20ECE23.e38f7e7e.jpg";